<template>
    <div class="ls-error--container">
        <img :src="require('./assets/warning.svg')" />
        <span>{{ message }}</span>
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsError',
    props: {
        message: VueTypes.string.def('Please fix the highlighted errors'),
    },
};
</script>

<style lang="scss" scoped>
.ls-error--container {
    padding: 8px 10px;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: $border-radius;
    border: 1px solid $danger;
    box-shadow: $box-shadow;

    > span {
        color: $danger;
        padding-left: 4px;
    }
}
</style>
